export default __webpack_public_path__ + "images/7240401618ed7526be7cec3b43684583-2_tablet_1067x470.jpg";